/* eslint-disable @typescript-eslint/no-unused-vars */
// import { useUsers } from "@/contexts/users.context";
// import { ActionConst } from "@/reducers/users.reducer";
import axios, { AxiosError, AxiosResponse } from "axios";

const useRequest = (baseURL: string = process.env.API_BASE_URL!) => {
    // console.log("🚀 ~ file: request.hook.ts:10 ~ useRequest ~ user:", user);
    // const { dispatch, isLoggedIn, access_token } = useUsers();

    const instance = axios.create({ baseURL, withCredentials: true });

    // Axios request interceptor.
    instance.interceptors.request.use(
        (request) => {
            console.log("🚀 ~ axios.interceptors.request", request.url);

            // request.baseURL = process.env.API_BASE_URL;
            return request;
        },
        (error) => {
            // Do something with request error
            return Promise.reject(error);
        },
    );

    // Axios response interceptor.
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const { data, status } = error.response;
            console.log("🚀 ~ axios.interceptors.response", data);

            return Promise.reject(error);
        },
    );

    // const request = ({ ...options }) => {
    //     const onSuccess = (res: AxiosResponse) => res.data;
    //     const onError = (err: AxiosError) => err.response;
    //     try {
    //         return instance(options);
    //     } catch (err: any) {
    //         const { response } = err as AxiosError;
    //         return { error: response?.data };
    //     }
    // };

    // const request = ({ ...options }) => {
    //     const onSuccess = (res: AxiosResponse) => res.data;
    //     const onError = (err: AxiosError) => err.response;
    //     return instance(options).then(onSuccess).catch(onError);
    // };

    // This fn is mostly used in useSWR.
    const fetcher = ({ ...options }) => {
        return instance(options).then((res) => res.data);
    };

    return { request: instance, fetcher };
};

export default useRequest;
